import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  isAuthenticated: false,
  isInitialized: false,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    updateUser: (state, action) => {
      state.user = JSON.parse(JSON.stringify(action.payload));
      let currentUser = state.user.accounts[0];
      state.user.profile = currentUser.profile;
      state.isAuthenticated = !!action.payload;
    },
    clearUser: (state) => {
      state.user = null;
      state.isAuthenticated = false;
    },
    setInitialized: (state, action) => {
      state.isInitialized = action.payload;
    },
  },
});

export const { updateUser, clearUser, setInitialized } = userSlice.actions;

export const setUser = (user) => (dispatch, getState) => {
  dispatch(updateUser(user));
  return getState().user.user;
};

export default userSlice.reducer;